import React from "react";

export default class Warning extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: props.message
        }
    }
    render() {
        let message = this.state.message;
        if(message != null && message !== "") {
            return(
                <div className="alert alert-warning" role="alert">
                    {this.state.message}
                </div>
            );
        } else {
            return (<p />);
        }

    }
}